import { useEffect, useRef, useState } from "react";

export default function UserScopeFilter({ value, onChange, onSearch }) {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    let cancelled = false;
    const handle = setTimeout(async () => {
      setLoading(true);
      try {
        const payload = await onSearch(query);
        if (!cancelled) setOptions(payload?.users || []);
      } catch {
        if (!cancelled) setOptions([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }, 200);
    return () => {
      cancelled = true;
      clearTimeout(handle);
    };
  }, [onSearch, open, query]);

  useEffect(() => {
    const onDocClick = (event) => {
      if (!wrapRef.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  if (value?.userId) {
    return (
      <div className="pa-scope">
        <span className="pa-scope-chip">
          {value.userName || value.userId}
          <button
            type="button"
            className="pa-scope-chip__clear"
            aria-label="Clear user filter"
            onClick={() => onChange(null)}
          >
            ×
          </button>
        </span>
      </div>
    );
  }

  return (
    <div className="pa-scope" ref={wrapRef}>
      <input
        type="search"
        role="combobox"
        className="pa-scope-input"
        placeholder="Search user"
        value={query}
        autoComplete="off"
        aria-label="Search user"
        aria-expanded={open}
        aria-controls="pa-scope-listbox"
        aria-autocomplete="list"
        onFocus={() => setOpen(true)}
        onChange={(event) => {
          setQuery(event.target.value);
          setOpen(true);
        }}
        onKeyDown={(event) => {
          if (event.key === "Escape") setOpen(false);
        }}
      />
      {open ? (
        <ul id="pa-scope-listbox" className="pa-scope-list" role="listbox">
          {loading ? <li className="pa-scope-empty">Searching…</li> : null}
          {!loading && !options.length ? (
            <li className="pa-scope-empty">No matching users</li>
          ) : null}
          {!loading
            ? options.map((user) => (
                <li key={user.userId}>
                  <button
                    type="button"
                    role="option"
                    aria-selected="false"
                    onMouseDown={(event) => event.preventDefault()}
                    onClick={() => {
                      onChange(user);
                      setQuery("");
                      setOpen(false);
                    }}
                  >
                    <strong>{user.userName}</strong>
                    <span>{user.userId}</span>
                  </button>
                </li>
              ))
            : null}
        </ul>
      ) : null}
    </div>
  );
}
